import React from 'react';
import CloudinaryAdvancedImage from '@common/utils/CloudinaryAdvancedImage';

function PageLoader() {

  return (
    <div className='lyt-home-loader'>
        <CloudinaryAdvancedImage imagePublicId="Sansaar_Website_2nd_July-01_1_2_mz9y6o" className='lyt-home-loader__image' type="main-hero-banner" />
    </div>
  )
}

export default PageLoader